<template>
  <AppHeader :action="{text: 'Add', route: 'CreateSubscription'}">Subscriptions</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <SearchSort
      ref="search"
      :defaults="{q: '', search: '-', sort: 'id', order: 'asc', group: '-'}"
      :sorts="{id: 'Subscription ID', created_at: 'Created At', start_date: 'Start Date', end_date: 'End Date', product_id: 'Product', status: 'Status', 'customer.id': 'Customer ID', 'customer.name': 'Customer Name', 'customer.wallet_balance': 'Customer Wallet', 'customer.dealer_sort': 'Customer Custom Sort', 'customer.status': 'Customer Status', 'deliveries_count': 'Deliveries'}"
      :columns="{id: 'ID', status: 'Status', 'customer.id': 'Customer ID', 'customer.name': 'Customer Name', 'product.quantity': 'Product Quantity'}"
      :groups="[]"
      @update="searchUpdated">
    </SearchSort>

    <div class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Created</th>
            <th>Customer</th>
            <th>Product</th>
            <th>Dates</th>
            <th>Type</th>
            <th>Curr. Dels</th>
            <th>Total Dels</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="sub in subscriptionsFiltered" :key="sub.id" :class="{'bg-yellow-300': sub.status == 'dealer-paused', 'bg-green-300': sub.status == 'created'}">
            <td><router-link :to="{name: 'ViewSubscription', params: {id: sub.id}}"><b>#{{ sub.id }}</b></router-link></td>
            <td>{{ toDate(sub.created_at, true) }}</td>
            <td><router-link :to="{name: 'ViewCustomer', params: {id: sub.customer.id}}"><b>{{ sub.customer.name }} ({{ toInr(sub.customer.wallet_balance) }}) <small>(#{{ sub.customer_id }})</small></b></router-link></td>
            <td>{{ sub.product.name }} ({{ sub.product.quantity }})</td>
            <td>{{ toDate(sub.start_date) }} <i class="ion-md-arrow-forward"></i> {{ sub.end_date ? toDate(sub.end_date) : 'NOT SET' }} <small>({{ diffBetweenDates(sub.start_date, sub.end_date) }} days)</small></td>
            <td><b>{{ sub.type }}</b></td>
            <td><b>{{ sub.deliveries_count }}</b></td>
            <td><b>{{ sub.total_deliveries }}</b></td>
            <td>{{ sub.status }}</td>
            <td>
              <span v-if="sub.status == 'dealer-paused'">
                <button @click="subAction(sub.id, 'activate')" class="px-2 py-1 mr-1 text-xs leading-none bg-green-300 rounded-full">Activate</button>
              </span>
              <span v-else>
                <button @click="subAction(sub.id, 'add', 7)" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-slate-300">+7</button>
                <button @click="subAction(sub.id, 'add', 10)" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-slate-300">+10</button>
                <button @click="subAction(sub.id, 'add', 15)" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-slate-300">+15</button>
                <button @click="subAction(sub.id, 'add', 30)" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-slate-300">+30</button>
                <button @click="subAction(sub.id, 'pause')" class="px-2 py-1 mr-1 text-xs leading-none bg-yellow-300 rounded-full">Pause</button>
                <button @click="subAction(sub.id, 'cancel')" class="px-2 py-1 mr-1 text-xs leading-none bg-red-300 rounded-full">Cancel</button>
              </span>
            </td>
          </tr>

          <tr v-if="data.subscriptions.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Subscriptions</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import SearchSort from '@/components/common/SearchSort.vue';

export default {
  name: 'Subscriptions',
  mixins: [ mixin ],
  components: { AppHeader, Loading, SearchSort },
  data() {
    return {
      state: 'loading',
      data: { subscriptions: [] },
      subscriptionsFiltered: [],
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'subscriptions', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.subscriptionsFiltered = resp.data.subscriptions;
          this.$nextTick(() => {
            this.$refs.search._emit();
          });
        }
      });
    },

    subAction(id, action, data = null) {
      if (!confirm('Are you sure?')) return;

      switch (action) {
        case 'activate':
          this.request('GET', 'subscriptions/' + id + '/active', {}, this.getData);
          break;

        case 'cancel':
          this.request('GET', 'subscriptions/' + id + '/cancel', {}, this.getData);
          break;

        case 'pause':
          this.request('GET', 'subscriptions/' + id + '/pause', {}, this.getData);
          break;

        case 'add':
          this.request('GET', 'subscriptions/' + id + '/add-days/' + data, {}, this.getData);
          break;
      }
    },

    searchUpdated(q, search, sort, order) {
      if (!q ||q == null || q.length == 0) this.subscriptionsFiltered = this.data.subscriptions;

      if (search == '-') this.subscriptionsFiltered = this.data.subscriptions.filter((item) => JSON.stringify(item).toLowerCase().includes(q.toLowerCase()));
      else this.subscriptionsFiltered = this.data.subscriptions.filter((item) => JSON.stringify(this.getDeepValue(item, search)).toLowerCase().includes(q.toLowerCase()));

      this.subscriptionsFiltered.sort((a, b) => {
        let aData = this.getDeepValue(a, sort), bData = this.getDeepValue(b, sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (order == 'desc' ? -1 : 1);
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
